<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Box Office Receipt Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("show") }}
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div> -->

          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getBoxOfficeReceiptReport(false)"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>
        </div>
      </div>

      <div
        class="d-flex justify-content-end mt-3 mb-1 align-items-center"
        v-if="combinedDataArr.length > 0"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- <a
          target="_blank"
          @click="generateReport('boxOfficeReceiptReport')"
          download
          title="Download as PDF"
          style="cursor:pointer"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a> -->

        <a
          target="_blank"
          @click="getBoxOfficeReceiptReport({ isPdf: 'Y', isPdf1: 'N' })"
          download
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>
        <!--
        <a
          target="_blank"
          @click="getBoxOfficeReceiptReport(true);"
          download
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a> -->

        <a href="#" @click="excelDownload()" title="Download as Excel">
          <img
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
        </a>
      </div>

      <!---Pdf starts box office-->
      <div class="d-none" style="font-size: 10px">
        <div class="table-scroll">
          <vue-html2pdf
            :show-layout="false"
            :float-layout="false"
            :enable-download="false"
            :paginate-elements-by-height="1400"
            :pdf-quality="1"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            @beforeDownload="beforeDownload($event)"
            ref="html2Pdf"
          >
            <div slot="pdf-content">
              <div
                style="width: 90%; margin-left: 25px"
                class="d-flex justify-content-between align-items-center mb-1"
              >
                <div class="d-block" style="font-size: 12px">
                  <p class="mb-1">Box Office Report</p>

                  <p class="mb-1">{{ dropDown.selectedCinemaName }}</p>

                  <p class="mb-1">
                    <span>Date: </span>{{ fromDate | dateparse }} -
                    {{ toDate | dateparse }}
                  </p>
                </div>

                <div class="d-block" style="font-size: 12px">
                  <div class="mb-1 d-flex justify-content-end">
                    <img
                      v-if="getOrganizationDetails"
                      :src="getOrganizationDetails.org_logo_url"
                      style="width: 150px"
                    />
                  </div>
                  <p class="mb-1 text-right" style="width: 180px">
                    {{ getOrganizationDetails.org_address }}
                  </p>
                </div>
              </div>

              <div
                class="d-flex mb-3 flex-wrap justify-content-between"
                v-if="false"
              >
                <div class="box-container mb-2 w-100 d-flex align-items-center">
                  <div class="p-2">
                    <img
                      v-if="getOrganizationDetails"
                      :src="getOrganizationDetails.org_logo_url"
                      style="width: 150px"
                    />
                  </div>
                  <div
                    class="d-block align-items-center text-center p-2"
                    style="border-left: 0.5px solid black"
                  >
                    <p class="mb-1">
                      {{ dropDown.selectedCinemaName }}
                    </p>
                    <p class="mb-1">{{ getOrganizationDetails.org_address }}</p>
                    <p class="mb-0"></p>
                    <p class="mb-1 font-weight-bold">
                      Box Office Receipt Report
                    </p>
                  </div>
                </div>

                <div
                  class="box-container mb-2 w-100 p-2 d-flex align-items-center"
                >
                  <span
                    ><span class="font-weight-bold">Screening Period: </span>
                    {{ fromDate | dateparse }} <span> TO </span>
                    {{ toDate | dateparse }}</span
                  >
                </div>

                <!-- <div class="mt-2">
            <span><span class="font-weight-bold">From Date:</span> {{fromDate | dateparse}}</span>
            <span class="ml-2"><span class="font-weight-bold">To Date:</span> {{toDate | dateparse}}</span>

            </div>
            <div class="d-flex mt-2">
             <span class="font-weight-bold">Generated At:</span> <span class="ml-1">{{moment().format('llll')}}</span>
            </div> -->
              </div>
              <table
                class="swc-report-table swc_table_header"
                style="width: 90%; margin-left: 25px"
                border="1"
                v-if="combinedDataArr.length > 0"
              >
                <thead class="bg-lightgrey">
                  <template v-for="(headerItem, headerIndex) in headerColumn">
                    <template v-if="headerItem.show">
                      <th
                        :key="headerIndex + 'headerData'"
                        :colspan="headerIndex == 0 ? 3 : 1"
                        v-html="headerItem.header_title"
                      ></th>
                    </template>
                  </template>
                </thead>
                <tbody>
                  <tr>
                    <td
                      colspan="3"
                      class="text-left no_border font-weight-bold"
                    >
                      Box Office
                    </td>
                  </tr>
                  <template v-if="boxOfficeFinalArray.length">
                    <template
                      v-for="(
                        boxOfficeFinalArrayItem, boxOfficeFinalArrayIndex
                      ) in boxOfficeFinalArray"
                    >
                      <tr
                        :key="boxOfficeFinalArrayIndex + 'boxOfficeIndex'"
                        class="no_border"
                        style="font-size: 12px"
                      >
                        <td class="text-left" colspan="3">
                          {{ boxOfficeFinalArrayItem.title }}
                        </td>
                        <td class="text-right">
                          {{ boxOfficeFinalArrayItem.admits }}
                        </td>
                        <td class="text-right">
                          {{
                            boxOfficeFinalArrayItem.t_gross_amount.toFixed(
                              MIN_FRACTION_DIGITS
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            boxOfficeFinalArrayItem.t_total_tax.toFixed(
                              MIN_FRACTION_DIGITS
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            boxOfficeFinalArrayItem.t_net_amount.toFixed(
                              MIN_FRACTION_DIGITS
                            )
                          }}
                        </td>
                      </tr>
                    </template>
                    <tr style="font-size: 12px">
                      <td colspan="3" class="no_border text-left">
                        Box Office Subject to tax this period
                      </td>
                      <td class="total_border text-right"></td>
                      <td class="total_border text-right">
                        {{
                          boxOfficeFinalObj.t_gross_amount_total.toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                      <td class="total_border text-right">
                        {{
                          boxOfficeFinalObj.t_tax_total.toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                      <td class="total_border text-right">
                        {{
                          boxOfficeFinalObj.t_net_amount_total.toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                    </tr>
                  </template>

                  <!-- Prepaid Sales -->
                  <tr>
                    <td
                      colspan="3"
                      class="pt-4 text-left no_border font-weight-bold"
                    >
                      Plus Prepaid Sales
                    </td>
                  </tr>
                  <template v-if="boxOfficeAdvanceFinalArray.length">
                    <template
                      v-for="(
                        boxOfficeAdvanceFinalArrayItem,
                        boxOfficeAdvanceFinalArrayIndex
                      ) in boxOfficeAdvanceFinalArray"
                    >
                      <tr
                        style="font-size: 12px"
                        :key="
                          boxOfficeAdvanceFinalArrayIndex +
                          'boxOfficeAdvanceIndex'
                        "
                        class="no_border"
                      >
                        <td class="text-left" colspan="3">
                          {{ boxOfficeAdvanceFinalArrayItem.title }}
                        </td>
                        <td class="text-right">
                          {{ boxOfficeAdvanceFinalArrayItem.admits }}
                        </td>
                        <td class="text-right">
                          {{
                            boxOfficeAdvanceFinalArrayItem.t_gross_amount.toFixed(
                              2
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            boxOfficeAdvanceFinalArrayItem.t_total_tax.toFixed(
                              2
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            boxOfficeAdvanceFinalArrayItem.t_net_amount.toFixed(
                              2
                            )
                          }}
                        </td>
                      </tr>
                    </template>
                    <tr style="font-size: 12px">
                      <td colspan="3" class="no_border text-left">
                        Total Box Office Receipts
                      </td>
                      <td class="total_border text-right"></td>
                      <td class="total_border text-right">
                        {{
                          boxOfficeAdvanceFinalObj.t_gross_amount_total.toFixed(
                            2
                          )
                        }}
                      </td>
                      <td class="total_border text-right">
                        {{
                          boxOfficeAdvanceFinalObj.t_tax_total.toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                      <td class="total_border text-right">
                        {{
                          boxOfficeAdvanceFinalObj.t_net_amount_total.toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                    </tr>
                  </template>

                  <template v-if="miscellenousArray.length">
                    <tr>
                      <td
                        colspan="3"
                        class="pt-4 text-left no_border font-weight-bold"
                      >
                        Miscellenaous
                      </td>
                    </tr>
                    <template
                      v-for="(
                        miscellenousArrayItem, miscellenousArrayIndex
                      ) in miscellenousArray"
                    >
                      <tr
                        style="font-size: 12px"
                        :key="miscellenousArrayIndex + 'miscellenousArrayIndex'"
                        class="no_border"
                      >
                        <td class="text-left" colspan="3">
                          {{ miscellenousArrayItem.title }}
                        </td>
                        <td class="text-right">
                          {{ miscellenousArrayItem.admits }}
                        </td>
                        <td class="text-right">
                          {{
                            miscellenousArrayItem.t_gross_amount.toFixed(
                              MIN_FRACTION_DIGITS
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            miscellenousArrayItem.t_total_tax.toFixed(
                              MIN_FRACTION_DIGITS
                            )
                          }}
                        </td>
                        <td class="text-right">
                          {{
                            miscellenousArrayItem.t_net_amount.toFixed(
                              MIN_FRACTION_DIGITS
                            )
                          }}
                        </td>
                      </tr>
                    </template>
                    <tr style="font-size: 12px">
                      <td colspan="3" class="no_border text-left">
                        Total Miscellaneous Sales
                      </td>
                      <td class="total_border text-right"></td>
                      <td class="total_border text-right">
                        {{
                          MiscellenousArrayObj.t_gross_amount_total.toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                      <td class="total_border text-right">
                        {{
                          MiscellenousArrayObj.t_tax_total.toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                      <td class="total_border text-right">
                        {{
                          MiscellenousArrayObj.t_net_amount_total.toFixed(
                            MIN_FRACTION_DIGITS
                          )
                        }}
                      </td>
                    </tr>
                  </template>
                  <tr class="font-weight-bold">
                    <td colspan="3" class="pt-5 no_border text-left">
                      Total Receipts
                    </td>
                    <td class="total_border text-right pt-5"></td>
                    <td class="total_border text-right pt-5">
                      {{
                        parseFloat(mainTotal.t_gross_amount_total).toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td class="total_border text-right pt-5">
                      {{
                        parseFloat(mainTotal.t_tax_total).toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td class="total_border text-right pt-5">
                      {{
                        parseFloat(mainTotal.t_net_amount_total).toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <!--Pdf Footer-->
              <div
                class="d-flex justify-content-between"
                style="width: 90%; margin-left: 25px"
              >
                <div class="d-flex">
                  <p class="mb-1">
                    <span class="font-weight-bold">Created/Printed: </span
                    >{{ moment().format("llll") }}
                  </p>
                </div>

                <div class="d-flex">
                  <p class="mb-1">{{ this.first_name }} {{ this.last_name }}</p>
                </div>
              </div>
            </div>
          </vue-html2pdf>
        </div>
      </div>
      <!---Pdf Ends box office-->

      <div>
        <div class="table-scroll">
          <table
            slot="pdf-content"
            class="swc-report-table swc_table_header"
            border="1"
            v-if="combinedDataArr.length > 0"
          >
            <thead class="bg-lightgrey">
              <template v-for="(headerItem, headerIndex) in headerColumn">
                <template v-if="headerItem.show">
                  <th
                    :key="headerIndex + 'headerData'"
                    :colspan="headerIndex == 0 ? 3 : 1"
                    v-html="headerItem.header_title"
                  ></th>
                </template>
              </template>
            </thead>
            <tbody>
              <tr>
                <td colspan="3" class="text-left no_border font-weight-bold">
                  Box Office
                </td>
              </tr>
              <template v-if="boxOfficeFinalArray.length">
                <template
                  v-for="(
                    boxOfficeFinalArrayItem, boxOfficeFinalArrayIndex
                  ) in boxOfficeFinalArray"
                >
                  <tr
                    :key="boxOfficeFinalArrayIndex + 'boxOfficeIndex'"
                    class="no_border"
                  >
                    <td class="text-left" colspan="3">
                      {{ boxOfficeFinalArrayItem.title }}
                    </td>
                    <td class="text-right">
                      {{ boxOfficeFinalArrayItem.admits }}
                    </td>
                    <td class="text-right">
                      {{
                        boxOfficeFinalArrayItem.t_gross_amount.toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        boxOfficeFinalArrayItem.t_total_tax.toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        boxOfficeFinalArrayItem.t_net_amount.toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                  </tr>
                </template>
                <tr>
                  <td colspan="3" class="no_border text-left">
                    Box Office Subject to tax this period
                  </td>
                  <td class="total_border text-right"></td>
                  <td class="total_border text-right">
                    {{
                      boxOfficeFinalObj.t_gross_amount_total.toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                  <td class="total_border text-right">
                    {{
                      boxOfficeFinalObj.t_tax_total.toFixed(MIN_FRACTION_DIGITS)
                    }}
                  </td>
                  <td class="total_border text-right">
                    {{
                      boxOfficeFinalObj.t_net_amount_total.toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                </tr>
              </template>

              <!-- Prepaid Sales -->
              <tr>
                <td
                  colspan="3"
                  class="pt-4 text-left no_border font-weight-bold"
                >
                  Plus Prepaid Sales
                </td>
              </tr>
              <template v-if="boxOfficeAdvanceFinalArray.length">
                <template
                  v-for="(
                    boxOfficeAdvanceFinalArrayItem,
                    boxOfficeAdvanceFinalArrayIndex
                  ) in boxOfficeAdvanceFinalArray"
                >
                  <tr
                    :key="
                      boxOfficeAdvanceFinalArrayIndex + 'boxOfficeAdvanceIndex'
                    "
                    class="no_border"
                  >
                    <td class="text-left" colspan="3">
                      {{ boxOfficeAdvanceFinalArrayItem.title }}
                    </td>
                    <td class="text-right">
                      {{ boxOfficeAdvanceFinalArrayItem.admits }}
                    </td>
                    <td class="text-right">
                      {{
                        boxOfficeAdvanceFinalArrayItem.t_gross_amount.toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        boxOfficeAdvanceFinalArrayItem.t_total_tax.toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        boxOfficeAdvanceFinalArrayItem.t_net_amount.toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                  </tr>
                </template>
                <tr>
                  <td colspan="3" class="no_border text-left">
                    Total Box Office Receipts
                  </td>
                  <td class="total_border text-right"></td>
                  <td class="total_border text-right">
                    {{
                      boxOfficeAdvanceFinalObj.t_gross_amount_total.toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                  <td class="total_border text-right">
                    {{
                      boxOfficeAdvanceFinalObj.t_tax_total.toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                  <td class="total_border text-right">
                    {{
                      boxOfficeAdvanceFinalObj.t_net_amount_total.toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                </tr>
              </template>

              <template v-if="miscellenousArray.length">
                <tr>
                  <td
                    colspan="3"
                    class="pt-4 text-left no_border font-weight-bold"
                  >
                    Miscellenaous
                  </td>
                </tr>
                <template
                  v-for="(
                    miscellenousArrayItem, miscellenousArrayIndex
                  ) in miscellenousArray"
                >
                  <tr
                    :key="miscellenousArrayIndex + 'miscellenousArrayIndex'"
                    class="no_border"
                  >
                    <td class="text-left" colspan="3">
                      {{ miscellenousArrayItem.title }}
                    </td>
                    <td class="text-right">
                      {{ miscellenousArrayItem.admits }}
                    </td>
                    <td class="text-right">
                      {{
                        miscellenousArrayItem.t_gross_amount.toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        miscellenousArrayItem.t_total_tax.toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                    <td class="text-right">
                      {{
                        miscellenousArrayItem.t_net_amount.toFixed(
                          MIN_FRACTION_DIGITS
                        )
                      }}
                    </td>
                  </tr>
                </template>
                <tr>
                  <td colspan="3" class="no_border text-left">
                    Total Miscellaneous Sales
                  </td>
                  <td class="total_border text-right"></td>
                  <td class="total_border text-right">
                    {{
                      MiscellenousArrayObj.t_gross_amount_total.toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                  <td class="total_border text-right">
                    {{
                      MiscellenousArrayObj.t_tax_total.toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                  <td class="total_border text-right">
                    {{
                      MiscellenousArrayObj.t_net_amount_total.toFixed(
                        MIN_FRACTION_DIGITS
                      )
                    }}
                  </td>
                </tr>
              </template>
              <tr class="font-weight-bold">
                <td colspan="3" class="pt-5 no_border text-left">
                  Total Receipts
                </td>
                <td class="total_border text-right pt-5"></td>
                <td class="total_border text-right pt-5">
                  {{
                    parseFloat(mainTotal.t_gross_amount_total).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="total_border text-right pt-5">
                  {{
                    parseFloat(mainTotal.t_tax_total).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
                <td class="total_border text-right pt-5">
                  {{
                    parseFloat(mainTotal.t_net_amount_total).toFixed(
                      MIN_FRACTION_DIGITS
                    )
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr />

      <div
        class="d-flex justify-content-end mt-3 mb-1 align-items-center"
        v-if="irregularTransactions.length > 0"
      >
        <div class="mx-1">{{ $t("download") }} as:</div>
        <!-- <a target="_blank" @click="generateReport('irregularTransactions')" download title="Download as PDF">
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a> -->
        <!-- <a
        target="_blank"
        href="#"
        title="Download as PDF"
        @click.prevent="printPdf = true;
        getBoxOfficeReceiptReport();"
        >
        <img
                  src="@/assets/img/icons/pdf-icon.svg"
                  height="25"
                  width="25"
                />
        </a> -->
        <a
          target="_blank"
          @click="getBoxOfficeReceiptReport({ isPdf: 'N', isPdf1: 'Y' })"
          download
          title="Download as PDF"
        >
          <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
        </a>

        <a href="#" @click="excelDownloadtwo()" title="Download as Excel">
          <img
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
        </a>
      </div>

      <!---Pdf Irregular Transaction Start-->
      <div class="d-none">
        <div class="table-scroll">
          <vue-html2pdf
            :show-layout="false"
            :float-layout="false"
            :enable-download="false"
            :paginate-elements-by-height="1400"
            :pdf-quality="1"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            pdf-content-width="100%"
            @beforeDownload="beforeDownload($event)"
            ref="html2Pdf_irregularTransactions"
          >
            <div slot="pdf-content">
              <div class="d-flex mb-3 flex-wrap justify-content-between">
                <span
                  ><span class="font-weight-bold">Cinema Name:</span>
                  {{ dropDown.selectedCinemaName }}</span
                >
                <div class="ml-5">
                  <span
                    ><span class="font-weight-bold">From Date:</span>
                    {{ fromDate | dateparse }}</span
                  >
                  <span class="ml-2"
                    ><span class="font-weight-bold">To Date:</span>
                    {{ toDate | dateparse }}</span
                  >
                </div>
                <div class="d-flex mt-4">
                  <span class="font-weight-bold">Generated At:</span>
                  <span class="ml-1">{{ moment().format("llll") }}</span>
                </div>
              </div>
              <table
                class="swc-report-table"
                v-if="irregularTransactions.length > 0"
              >
                <thead>
                  <tr>
                    <th>IRREGULAR TRANSACTIONS</th>
                    <th>QTY</th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-for="(
                      transactionData, transactionIndex
                    ) in irregularTransactions"
                  >
                    <tr :key="transactionIndex + 'irregularTransactions'">
                      <td class="text-left">{{ transactionData.title }}</td>
                      <td class="text-right">{{ transactionData.quantity }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </vue-html2pdf>
        </div>
      </div>

      <!---Pdf Irregular Transaction End-->

      <div>
        <div class="table-scroll">
          <table
            class="swc-report-table"
            v-if="irregularTransactions.length > 0"
          >
            <thead>
              <tr>
                <th class="text-capitalize">Irregular Transaction</th>
                <th class="text-capitalize">QTY</th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(
                  transactionData, transactionIndex
                ) in irregularTransactions"
              >
                <tr :key="transactionIndex + 'irregularTransactions'">
                  <td class="text-left text-capitalize">
                    {{ transactionData.title }}
                  </td>
                  <td class="text-right">{{ transactionData.quantity }}</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <table
        v-if="combinedDataArr.length == 0"
        class="swc-report-table swc_table_header"
        border="1"
      >
        <thead class="bg-lightgrey">
          <th>Name</th>
          <th>Admits</th>
          <th>Total Sales(incl. tax)</th>
          <th>Tax</th>
          <th>Net Value</th>
        </thead>
        <tbody>
          <tr>
            <td colspan="5">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="irregularTransactions.length == 0">
        <table class="swc-report-table mt-3">
          <thead>
            <tr>
              <th>IRREGULAR TRANSACTIONS</th>
              <th>QTY</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <NoRecords />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      htmlToPdfOptions: {
        filename: "Box Office Receipt Report",
        margin: 3,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: {
          scale: 1,
          useCORS: true,
        },
        jsPDF: {
          format: "a4",
          orientation: "portrait",
        },
      },
      fromDate: new Date(),
      toDate: new Date(),
      headerArr: [],
      combinedDataArr: [],
      boxOfficeFinalArray: [],
      headerColumn: [],
      miscellenousArray: [],
      boxOfficeAdvanceFinalArray: [],
      boxOfficeFinalObj: {
        t_gross_amount_total: 0,
        t_tax_total: 0,
        t_net_amount_total: 0,
      },
      boxOfficeAdvanceFinalObj: {
        t_gross_amount_total: 0,
        t_tax_total: 0,
        t_net_amount_total: 0,
      },
      MiscellenousArrayObj: {
        t_gross_amount_total: 0,
        t_tax_total: 0,
        t_net_amount_total: 0,
      },
      mainTotal: {
        t_gross_amount_total: 0,
        t_tax_total: 0,
        t_net_amount_total: 0,
      },
      irregularTransactions: [],
      first_name: "",
      last_name: "",
      // printPdf:false,
    };
  },
  computed: {
    ...mapGetters(["getOrganizationDetails"]),
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    const { first_name, last_name } = this.secureStore.get("USINFO");
    this.first_name = first_name;
    this.last_name = last_name;
    if (CinemaObj) {
      this.onSelectCinema(CinemaObj);
    }
    console.log(this.secureStore.get("USINFO"), "Usinfo");
  },
  watch: {
    "$store.getters.getSelectedDropDownCinema": function (CinemaObj) {
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }
    },
  },
  mounted() {},
  methods: {
    moment,
    async beforeDownload({ html2pdf, options, pdfContent }) {
      const date = new Date();
      this.pdfFileName = "Reports" + date.getTime();
      this.htmlToPdfOptions.filename =
        "Box Office Receipt Report" + date.getTime();
      await html2pdf()
        .set(this.htmlToPdfOptions)
        .from(pdfContent)
        .toPdf()
        .get("pdf")
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages();
          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            pdf.text(
              "Page " + i + " of " + totalPages,
              pdf.internal.pageSize.getWidth() * 0.88,
              pdf.internal.pageSize.getHeight() - 0.3
            );
          }
        })
        .save();
    },

    generateReport(type) {
      if (type == "boxOfficeReceiptReport") {
        this.$refs.html2Pdf &&
          this.$refs.html2Pdf.generatePdf &&
          this.$refs.html2Pdf.generatePdf();
      } else {
        this.$refs.html2Pdf_irregularTransactions &&
          this.$refs.html2Pdf_irregularTransactions.generatePdf &&
          this.$refs.html2Pdf_irregularTransactions.generatePdf();
      }
    },
    getCinemaList: function () {
      MasterService.GetCinemasByRoles()
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    ResetState: function () {
      // reset state
      this.boxOfficeFinalObj = {
        t_gross_amount_total: 0,
        t_tax_total: 0,
        t_net_amount_total: 0,
      };
      this.boxOfficeAdvanceFinalObj = {
        t_gross_amount_total: 0,
        t_tax_total: 0,
        t_net_amount_total: 0,
      };
      this.MiscellenousArrayObj = {
        t_gross_amount_total: 0,
        t_tax_total: 0,
        t_net_amount_total: 0,
      };
      this.mainTotal = {
        t_gross_amount_total: 0,
        t_tax_total: 0,
        t_net_amount_total: 0,
      };
      this.combinedDataArr = [];
      this.irregularTransactions = [];
      this.headerColumn = [];
      this.boxOfficeFinalArray = [];
      this.miscellenousArray = [];
      this.boxOfficeAdvanceFinalArray = [];
    },
    getBoxOfficeReceiptReport: function ({ isPdf = "N", isPdf1 = "N" }) {
      this.submitted = true;
      this.getBoxOfficeReport = [];
      if (!this.fromDate) {
        return this.$toasted.show("Please select from date");
      }
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Please select cinema");
      }
      let loader = this.$loading.show();

      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName,
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.fromDate).add(1, "days").format("YYYY-MM-DD"),
        isPdf,
        isPdf1,
      };
      this.ResetState();
      ReportsService.GetBoxOfficeReceiptSummary(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            // console.log("data from api", data);
            this.combinedDataArr = [
              data.BoxOfficeFinalArray,
              data.MiscellenousArray,
              data.BoxOfficeAdvanceFinalArray,
            ];
            this.irregularTransactions = data.irregular_response;
            this.headerColumn = data.header_column;
            this.boxOfficeFinalArray = data.BoxOfficeFinalArray;
            this.miscellenousArray = data.MiscellenousArray;
            this.boxOfficeAdvanceFinalArray = data.BoxOfficeAdvanceFinalArray;
            if (this.irregularTransactions.length > 0) {
              if (isPdf1 && data.pdfpath1) {
                window.open(data.pdfpath1, "_blank");
              }
            }
            if (this.boxOfficeFinalArray.length > 0) {
              if (isPdf && data.pdfpath) {
                window.open(data.pdfpath, "_blank");
              }
              this.boxOfficeFinalObj = {
                t_gross_amount_total:
                  parseFloat(this.boxOfficeFinalArray[0]["t_gross_amount"]) -
                  +parseFloat(this.boxOfficeFinalArray[1]["t_gross_amount"]) -
                  +parseFloat(this.boxOfficeFinalArray[2]["t_gross_amount"]),
                t_tax_total:
                  parseFloat(this.boxOfficeFinalArray[0]["t_total_tax"]) -
                  +parseFloat(this.boxOfficeFinalArray[1]["t_total_tax"]) -
                  +parseFloat(this.boxOfficeFinalArray[2]["t_total_tax"]),
                t_net_amount_total:
                  parseFloat(this.boxOfficeFinalArray[0]["t_net_amount"]) -
                  +parseFloat(this.boxOfficeFinalArray[1]["t_net_amount"]) -
                  +parseFloat(this.boxOfficeFinalArray[2]["t_net_amount"]),
              };
            }
            if (this.boxOfficeAdvanceFinalArray.length > 0) {
              this.boxOfficeAdvanceFinalObj = {
                t_gross_amount_total:
                  parseFloat(this.boxOfficeFinalObj["t_gross_amount_total"]) +
                  parseFloat(
                    this.boxOfficeAdvanceFinalArray[0]["t_gross_amount"]
                  ) -
                  +parseFloat(
                    this.boxOfficeAdvanceFinalArray[1]["t_gross_amount"]
                  ),
                t_tax_total:
                  parseFloat(this.boxOfficeFinalObj["t_tax_total"]) +
                  parseFloat(
                    this.boxOfficeAdvanceFinalArray[0]["t_total_tax"]
                  ) -
                  parseFloat(this.boxOfficeAdvanceFinalArray[1]["t_total_tax"]),
                t_net_amount_total:
                  parseFloat(this.boxOfficeFinalObj["t_net_amount_total"]) +
                  parseFloat(
                    this.boxOfficeAdvanceFinalArray[0]["t_net_amount"]
                  ) -
                  parseFloat(
                    this.boxOfficeAdvanceFinalArray[1]["t_net_amount"]
                  ),
              };
            }
            if (this.miscellenousArray.length > 0) {
              this.MiscellenousArrayObj = {
                t_gross_amount_total: this.miscellenousArray.reduce(
                  (acc, { t_gross_amount }) => {
                    return acc + t_gross_amount;
                  },
                  0
                ),
                t_tax_total: this.miscellenousArray.reduce(
                  (acc, { t_total_tax }) => {
                    return acc + t_total_tax;
                  },
                  0
                ),
                t_net_amount_total: this.miscellenousArray.reduce(
                  (acc, { t_net_amount }) => {
                    return acc + t_net_amount;
                  },
                  0
                ),
              };
            }
            this.mainTotal["t_gross_amount_total"] =
              parseFloat(
                this.boxOfficeAdvanceFinalObj["t_gross_amount_total"]
              ) + parseFloat(this.MiscellenousArrayObj["t_gross_amount_total"]);
            this.mainTotal["t_tax_total"] =
              parseFloat(this.boxOfficeAdvanceFinalObj["t_tax_total"]) +
              parseFloat(this.MiscellenousArrayObj["t_tax_total"]);
            this.mainTotal["t_net_amount_total"] =
              this.boxOfficeAdvanceFinalObj["t_net_amount_total"] +
              this.MiscellenousArrayObj["t_net_amount_total"];
            // if(this.headerColumn.length>0){
            //   this.headerColumn.map((h_c)=>{
            //     if(h_c.show){
            //       this.headerArr.push(h_c.key)
            //     }
            //   })
            // }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 660);
        });
    },
    excelDownloadtwo() {
      let new_records = this.irregularTransactions;

      let data = [
        {
          sheet: "Irregular Transaction Report",
          columns: [
            {
              value: "title",
              label: "Irregular Transactoion",
            },
            {
              value: "quantity",
              label: "Qty",
            },
          ],
          content: new_records,
        },
      ];
      let settings = {
        fileName: `IrregularTransactionReport${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },

    excelDownload() {
      this.boxOfficeFinalArray.forEach((x) => {
        x["main_title_name"] = "BoxOffice";
      });
      this.boxOfficeAdvanceFinalArray.forEach((x) => {
        x["main_title_name"] = "Plus Prepaid Sales";
      });
      this.miscellenousArray.forEach((x) => {
        x["main_title_name"] = "Miscellaneous Sales";
      });
      let new_records = [
        ...this.boxOfficeFinalArray,
        ...this.boxOfficeAdvanceFinalArray,
        ...this.miscellenousArray,
      ];
      // let temp_arr = this.getBoxOfficeReport;
      // temp_arr = this.getBoxOfficeReport.map(x => {
      // x.paymentData.map(z => {
      // let obj = {
      // ...x,
      // ...z
      // };
      // new_records.push(obj);
      // });
      // });
      // let temp_arr_fnb = this.getBoxOfficeFnBReport.map(p => {
      // p["booking_source"] = "FNB";
      // new_records.push(p);
      // });
      // console.log("new_records", new_records);
      let data = [
        {
          sheet: "BoxOfficeReceipt Report",
          columns: [
            {
              value: "main_title_name",
              label: "Title Name",
            },
            {
              value: "title",
              label: "",
            },
            {
              value: "admits",
              label: "Admits",
            },
            {
              value: (row) =>
                +parseFloat(row.t_gross_amount).toFixed(
                  this.MIN_FRACTION_DIGITS
                ),
              label: "Box Office Gross (inc tax)",
            },
            {
              value: (row) =>
                +parseFloat(row.t_total_tax).toFixed(this.MIN_FRACTION_DIGITS),
              label: "Tax",
            },
            {
              value: (row) =>
                +parseFloat(row.t_net_amount).toFixed(this.MIN_FRACTION_DIGITS),
              label: "Net",
            },
          ],
          content: new_records,
        },
      ];
      let settings = {
        fileName: `BoxOfficeReceiptReport${new Date().getTime()}`,
      };
      xlsx(data, settings);
    },
  },
};
</script>

<style>
.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  border: 1px solid black;
}

.swc-report-table th {
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}

.no_border,
.no_border td {
  border: 0px #fff;
}

.total_border,
.total_border td {
  border-left: 0px #fff;
  border-right: 0px #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/boxOfficeReceiptReportAddOns.vue